module.exports = __webpack_public_path__ + "static/media/sliderImage1.8b1e6e71.png";